import createElement from "../../../../../helpers/createElement";
import {setAsDateField} from "../../../../../helpers/inputs";
import moment from "moment/moment";

class CustomDateCellEditor {
	/** @type {HTMLElement} */
	guiElement;
	/** @type {HTMLInputElement} */
	baseInput;

	/**
	 * @param {import('ag-grid-community/dist/lib/interfaces/iCellEditor').ICellEditorParams} params
	 */
	init(params) {
		// noinspection JSUnresolvedReference
		const dateValueAsMoment = moment(params.data[params.dateField])

		// noinspection JSUnresolvedReference
		if (params.isEndDate) {
			dateValueAsMoment.subtract('1', 'day');
		}

		this.guiElement = createElement(`
			<div class="form-group m-0">
				<input type="text" name="cell-date-input" autocomplete="off" class="form-control" value="${dateValueAsMoment.format('MM/DD/YYYY')}">
			</div>
		`);

		this.baseInput = this.guiElement.querySelector('input');

		// Init datetimepicker
		setAsDateField(this.baseInput, {
			date: dateValueAsMoment.format('MM/DD/YYYY')
		})

		// End edit when picker is closed
		$(this.baseInput).on('dp.hide', () => {
			params.api.stopEditing();
		})
	}

	// after this component has been created and inserted into the grid
	// noinspection JSUnusedGlobalSymbols
	afterGuiAttached() {
		this.baseInput.focus();
	}

	// Mandatory - Return the DOM element of your editor, this is what the grid puts into the DOM
	// noinspection JSUnusedGlobalSymbols
	getGui() {
		return this.guiElement;
	};

	// Mandatory - Return the final value - called by the grid once after editing is complete
	// noinspection JSUnusedGlobalSymbols
	getValue() {
		return this.baseInput.value;
	};

	// Gets called once after initialised. If you return true, the editor will
	// appear in a popup, so is not constrained to the boundaries of the cell.
	// This is great if you want to, for example, provide you own custom dropdown list
	// for selection. Default is false (ie if you don't provide the method).
	// noinspection JSUnusedGlobalSymbols
	isPopup() {
		return true;
	};

	// Gets called once, only if isPopup() returns true. Return "over" if the
	// popup should cover the cell, or "under" if it should be positioned below
	// leaving the cell value visible. If this method is not present, the
	// default is "over"
	// noinspection JSUnusedGlobalSymbols
	getPopupPosition() {
		return 'over';
	};
}

export {CustomDateCellEditor}
